import './SessionExpirationNotification.css'

import { useAuth } from 'hooks/admin/useAuth'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

interface SessionExpirationNotificationProps {
    children: React.ReactNode
}

const SessionExpirationNotification: React.FC<SessionExpirationNotificationProps> = ({ children }) => {
    const { currentUser, isTokenExpired } = useAuth()
    const [showNotification, setShowNotification] = useState(false)
    const navigate = useNavigate()

    useEffect(() => {
        let interval: NodeJS.Timeout | null = null

        const checkSessionExpiration = async () => {
            if (currentUser) {
                const isExpired = await isTokenExpired()
                setShowNotification(isExpired)
            } else {
                setShowNotification(false)
            }
        }

        checkSessionExpiration()

        interval = setInterval(checkSessionExpiration, 30000)

        return () => {
            if (interval) clearInterval(interval)
        }
    }, [currentUser, isTokenExpired])

    const handleLoginClick = () => {
        navigate('/login')
    }

    return (
        <>
            {children}
            {showNotification && (
                <div className="session-expiration-notification">
                    <p>Your session has expired. Please log in again to continue.</p>
                    <button onClick={handleLoginClick}>Log In</button>
                </div>
            )}
        </>
    )
}

export default SessionExpirationNotification
